import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const FeedbackCommentRequest = {
  getFeedbackCommentListByProcedureId: comId =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-comment/procedure/${comId}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  getDetailFeedbackComment: id =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-comment-details/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  updateFeedbackCommentDetail: (id, updatedData) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/feedback-comment-details/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: updatedData,
    }),

  getFeedbackCommentById: id =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-comment/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  getDetailFeedbackByCommentIdAndUsername: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-comment-details/by-feedback-comment-and-username`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),

  createFeedbackComment: (dataSubmit, id) =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/feedback-comment-details/${id}/details`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: dataSubmit,
    }),

  getFeedbackCommentByIdV2: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-comment/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  getFeedbackCommentFileName: fileid =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-comment/file/${fileid}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  getFeedbackCommentByCode: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-comment/view/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  updateFeedbackCommentStatus: (data, code) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/feedback-comment/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  updateFileElectronic: (file_id, action, code) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/feedback-comment/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: {
        file_id: file_id,
        action: action,
      },
    }),

  deleteFeedbackComment: code =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/feedback-comment/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  // comment
  getCommentFeedbackCommentList: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-comment/${code}/comments`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  createCommentFeedbackComment: (code, data) =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/feedback-comment/${code}/comments`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  deleteCommentFeedbackComment: (code, id_comment) =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/feedback-comment/${code}/comments/${id_comment}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
}
